import { MessageSquare, Wand2, Rocket, RefreshCw } from "lucide-react";

const steps = [
    {
        Icon: MessageSquare,
        n: "01",
        title: "Tell us what hurts",
        desc: "30-min discovery call. We map your manual workflows, bottlenecks, and the AI use case that pays back fastest.",
    },
    {
        Icon: Wand2,
        n: "02",
        title: "We build the bot",
        desc: "You get a working prototype in 3–7 days — not 3 months. Connected to your stack, trained on your data.",
    },
    {
        Icon: Rocket,
        n: "03",
        title: "Ship & measure",
        desc: "Deploy on day one. We monitor performance, usage, and ROI from kickoff — fully transparent dashboards.",
    },
    {
        Icon: RefreshCw,
        n: "04",
        title: "Iterate forever",
        desc: "Your agent evolves with your business. New features, retraining, integrations — all included in the monthly retainer.",
    },
];

export default function EzProcess() {
    return (
        <section
            id="process"
            data-testid="process-section"
            className="relative py-24 sm:py-32 scroll-mt-nav"
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
                <div className="max-w-2xl mb-16">
                    <span className="text-[11px] font-bold uppercase tracking-[0.25em] text-[#00f0ff]">
                        The ez process
                    </span>
                    <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter mt-4 leading-[1.05]">
                        Four steps from{" "}
                        <span className="text-gradient-cyan">idea to deployed</span>.
                    </h2>
                    <p className="text-lg text-[#94a3b8] mt-6 leading-relaxed">
                        We strip the agency theater. No bloated SOWs, no &ldquo;kickoff workshops,&rdquo;
                        no waiting on three layers of project managers. Just builders who ship.
                    </p>
                </div>

                <div className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/10 rounded-2xl overflow-hidden">
                    {steps.map(({ Icon, n, title, desc }, i) => (
                        <div
                            key={n}
                            data-testid={`process-step-${i + 1}`}
                            className="relative group bg-[#0a1325] p-8 sm:p-10 hover:bg-[#0d1830] transition-colors duration-300"
                        >
                            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00f0ff]/0 to-transparent group-hover:via-[#00f0ff]/60 transition-all duration-500" />
                            <div className="flex items-start justify-between mb-8">
                                <div className="w-12 h-12 rounded-lg bg-[#00f0ff]/10 border border-[#00f0ff]/30 flex items-center justify-center group-hover:bg-[#00f0ff]/20 group-hover:border-[#00f0ff]/60 transition-all">
                                    <Icon className="w-5 h-5 text-[#00f0ff]" strokeWidth={2} />
                                </div>
                                <span className="font-mono text-xs text-[#475569] tracking-widest">
                                    {n}
                                </span>
                            </div>
                            <h3 className="font-heading text-xl font-bold mb-3 tracking-tight">
                                {title}
                            </h3>
                            <p className="text-sm text-[#94a3b8] leading-relaxed">{desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
